import { fontText, StylesIndexInjections } from 'common-react';
import { createStyles, makeUiStyles, Theme } from '../../../styles/styles';

export default makeUiStyles((theme: Theme) => createStyles({
  root: {
    padding: '20px 32px',
    margin: '24px -32px -32px -32px',
    backgroundColor: theme.color.greys[10],
    font: fontText('normal', theme.fontSize.s, 20),
    color: theme.color.greys[50],
    [theme.breakpoints.down('xs')]: {
      padding: '16px 40px',
    },
  }
}), { name: 'ProcessFooter', index: StylesIndexInjections.UI_ATOMS });
